import { render, staticRenderFns } from "./SubMenu.vue?vue&type=template&id=5bf3b09c&scoped=true"
import script from "./SubMenu.vue?vue&type=script&lang=ts"
export * from "./SubMenu.vue?vue&type=script&lang=ts"
import style0 from "./SubMenu.vue?vue&type=style&index=0&id=5bf3b09c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf3b09c",
  null
  
)

export default component.exports